import produce from "immer";

import setKeypathValue from "@/redux/utils/setKeypathValue";
import { STATUS } from "@/utils/constants";

import {
  RESET,
  SET_IS_CONFIRMATION_MODAL_VISIBLE,
  SET_IS_FETCHING_STATUS,
  SET_IS_SAVING_STATUS,
  SET_NEW_PRODUCT_DATA,
  SET_PRODUCTS,
} from "./splitOrders.actionTypes";

const initialState = {
  isFetchingStatus: STATUS.IDLE,
  isSavingStatus: STATUS.IDLE,
  products: [],
  isConfirmationModalVisible: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_FETCHING_STATUS: {
      return {
        ...state,
        isFetchingStatus: action.payload,
      };
    }

    case SET_IS_SAVING_STATUS: {
      return {
        ...state,
        isSavingStatus: action.payload,
      };
    }

    case SET_PRODUCTS: {
      return {
        ...state,
        products: action.payload,
      };
    }

    case SET_IS_CONFIRMATION_MODAL_VISIBLE: {
      return {
        ...state,
        isConfirmationModalVisible: action.payload,
      };
    }

    case SET_NEW_PRODUCT_DATA: {
      const { path, value } = action.payload;
      return produce(state, (draft) => {
        setKeypathValue(draft, ["products", ...path], value);
      });
    }

    case RESET: {
      return { ...initialState };
    }

    default:
      return state;
  }
};
